// @ts-check
// Contêiner do painel lateral: coluna à direita no desktop (400 px), tela cheia no mobile.
import { html } from 'htm/preact';
import { useEffect } from 'preact/hooks';
import { sidePanelState, closeSidePanel } from './side-panel-state.js';
import { CommandMenuPage } from './command-menu.js';
import { CreateRecordPanel } from './create-record-panel.js';
import { NewConversationPanel } from '../conversations/new-conversation-panel.js';
import { WidgetEditorPanel } from '../dashboards/widget-editor-panel.js';
import { UpdateRecordsPanel } from './update-records-panel.js';
import { MergeRecordsPanel } from './merge-records-panel.js';
import { NoteEditorPanel } from '../record-show/note-editor-panel.js';
import { RecordSidePanel } from './record-panel.js';

export function SidePanel() {
  const page = sidePanelState.value;

  useEffect(() => {
    if (!page) return undefined;
    /** @param {KeyboardEvent} event */
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !event.defaultPrevented && page.page !== 'command-menu') {
        const target = /** @type {HTMLElement} */ (event.target);
        if (target.closest?.('[data-dropdown-surface]')) return;
        // Esc dentro de um campo em edição do registro fecha só o campo
        if (page.page === 'record' && target.closest?.('.field-input-surface, .record-title-editing, [contenteditable="true"]')) return;
        closeSidePanel();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [page]);

  return html`<aside class="side-panel" data-open=${page ? 'true' : undefined} data-page=${page?.page} aria-hidden=${page ? undefined : 'true'}>
    ${page?.page === 'record' ? html`<${RecordSidePanel} stack=${page.stack} />` : null}
    ${page?.page === 'command-menu' ? html`<${CommandMenuPage} />` : null}
    ${page?.page === 'create-record'
      ? html`<${CreateRecordPanel}
          key=${`${page.objectNameSingular}-${JSON.stringify(page.prefill ?? {})}`}
          objectNameSingular=${page.objectNameSingular}
          prefill=${page.prefill}
          onCreated=${page.onCreated}
          priorityFieldNames=${page.priorityFieldNames}
          objectLabel=${page.objectLabel}
        />`
      : null}
    ${page?.page === 'new-conversation'
      ? html`<${NewConversationPanel}
          key=${page.key}
          defaultChannelType=${page.defaultChannelType}
          defaultTo=${page.defaultTo}
          personId=${page.personId}
          onCreated=${page.onCreated}
        />`
      : null}
    ${page?.page === 'dashboard-widget' ? html`<${WidgetEditorPanel} widgetKey=${page.widgetKey} />` : null}
    ${page?.page === 'update-records'
      ? html`<${UpdateRecordsPanel} key=${page.key} objectNameSingular=${page.objectNameSingular} ids=${page.ids} presetFieldName=${page.presetFieldName} onDone=${page.onDone} />`
      : null}
    ${page?.page === 'merge-records'
      ? html`<${MergeRecordsPanel} key=${page.key} objectNameSingular=${page.objectNameSingular} ids=${page.ids} onDone=${page.onDone} />`
      : null}
    ${page?.page === 'note-editor'
      ? html`<${NoteEditorPanel} key=${page.key} noteId=${page.noteId} targetObjectNameSingular=${page.targetObjectNameSingular}
          targetRecordId=${page.targetRecordId} onSaved=${page.onSaved} />`
      : null}
  </aside>`;
}
